// 子组件：优惠券弹窗
import React from 'react'
import { CenterPopup } from 'antd-mobile'
import { CloseOutline } from 'antd-mobile-icons'
import CouponList from '../CouponList'
import './index.less'
import styles from '../../components/JmModal/index.module.less'

const CouponModal = React.memo(({ visible, coupon, onClose, storeId = '', placeFlag = '' }) => {
    if (!visible || !coupon) return null

    return (
        <CenterPopup
            visible={visible}
            onClose={onClose}
            closeOnMaskClick
            destroyOnClose
            bodyStyle={{ backgroundColor: 'transparent' }}
            style={{ '--min-width': '92%' }}
        >
            <div className={`${styles.jmModal} ${styles.selCouponModal} p10`}>
                <div
                    style={{ fontWeight: 'bold', fontSize: '18px', marginBottom: 12 }}
                    className={`${styles.modalTitle} text-center`}
                >
                    {coupon.activityTitle || 'Receive Your Coupons'}&nbsp;
                </div>
                <div className={`${styles.modalContent}`} style={{ minHeight: 200 }}>
                    <CouponList
                        activityCoupons={coupon.list?.length > 0 ? coupon.list : [{ ...coupon }]}
                        ids={coupon.param2}
                        style={{ backgroundColor: 'transparent' }}
                        cls='popup-coupon-wrapper'
                        from='popup'
                        storeId={storeId}
                        placeFlag={placeFlag}
                    />
                </div>
            </div>
            <div className={styles.modalClose}>
                <CloseOutline fontSize={28} color='#fff' onClick={onClose} />
            </div>
        </CenterPopup>
    )
})

export default CouponModal